import { CorrespondenceChecker } from 'product_modules/utils/valueVisualTypeCorrespondenceCheckers/Types';
import { VariableValue } from 'product_modules/api/Types';

const isCorrespondsNumber: CorrespondenceChecker<number> = (value: VariableValue): value is number => {
  return typeof value === 'number';
};

export default isCorrespondsNumber;
